import { connect } from "react-redux";

import { setEmptyUnitsVisible } from "../../../../Engine/ActionCreators/HiddenPanelActionCreators";
import { CandyDispatch } from "../../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../../Engine/Core/Store/FullFormState";
import { currentViewModelSelect } from "../../../../Helpers/StateAccessors/ViewModelSelect";
import { UnitIdSet } from "../../Unit/UnitId/UnitIdImmutableSet";

import { HideUnitButton, HideUnitButtonProps } from "./HideUnitButton";

type MappedProps = Pick<HideUnitButtonProps, "hasEmptyUnit" | "emptyUnitsVisible" | "isReadOnly">;

function mapStateToProps(state: FullFormState): MappedProps {
    const hasEmptyUnit = !UnitIdSet.isEmpty(state.emptyUnits);
    const draftMeta = currentViewModelSelect.draftMeta(state);

    const emptyUnitsVisible =
        draftMeta != undefined && draftMeta.emptyUnitsVisible != undefined ? draftMeta.emptyUnitsVisible : true;
    return {
        hasEmptyUnit: hasEmptyUnit,
        emptyUnitsVisible: emptyUnitsVisible,
        isReadOnly: state.settings.isReadOnly,
    };
}

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    onChangeEmptyUnitsVisible: (isVisible: boolean) => {
        dispatch(setEmptyUnitsVisible(isVisible));
    },
});

export const HideUnitButtonContainer = connect(mapStateToProps, mapDispatchToProps)(HideUnitButton);
